import React from 'react';
import { useSelector } from 'react-redux';

import { Language } from '../../../utils';
import { Button } from '../../../components';

import makeClasses from '../styles';
import clsx from 'clsx';
import { Alert, AlertTitle } from '@material-ui/lab';
import SentimentDissatisfiedOutlinedIcon from '@material-ui/icons/SentimentDissatisfiedOutlined';

const StepSix = ({ onBackToStart }) => {
  const classes = makeClasses();

  const { languageTexts } = useSelector(state => ({
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  return (
    <React.Fragment>
      <div className={classes.formContent}>
        <div className={classes.formTitleContainer}>
          <div className={classes.formTitle}>{i18n.get('Register.StepFormTitle')}</div>
        </div>
        <Alert
          severity="warning"
          icon={false}
          className={clsx(classes.alert, classes.alertError, classes.alertWithNoMarginBottom)}>
          <SentimentDissatisfiedOutlinedIcon className={classes.alertIcon} />
          <div className={classes.alertMessage}>
            <AlertTitle className={classes.alertTitle}>
              {i18n.get('Register.Step6ConfirmationTitle')}
            </AlertTitle>
            <div>{i18n.get('Register.Step6ConfirmationMessage')}</div>
          </div>
        </Alert>
        <div className={clsx(classes.formSubmitContainer, classes.formSubmitContainerWithOneButton)}>
          <Button className={classes.formSubmitButton} onClick={onBackToStart}>
            {i18n.get('Register.BackToStart')}
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

StepSix.id = 'com.Handy.Register.StepSix';
export default StepSix;
